import { Model } from "@rematch/core";
import { IApplication } from "shared/model/IApplication";
import { ICoworkBranch, ICoworkSpace } from "shared/model/ICoworkSpace";

import { emptyListSubState, IdToObjectMap } from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { IApplicationCreationProps } from "./../../model/IApplicationCreationProps";
import { IListSubState } from "./../../model/SharedTypes";
import ApplicationsEffects from "./ApplicationsEffetcs";
import ApplicationsReducers from "./ApplicationsReducers";

export interface IApplicationsModel extends Model {
  name: StateModules;
  state: IApplicationsState;
  reducers: IApplicationsReducers;
  effects: IApplicationsEffects;
}

export type IApplicationsState = {
  currentCoworkSpace?: ICoworkSpace;
  currentCoworkBranch?: ICoworkBranch;
  branches: ICoworkBranch[];
  applications: IdToObjectMap<IApplication>;
  applicationsForCurrentCowork: IListSubState;
  creation?: {
    inProgress: boolean;
    error?: string;
  };
  lastCreatedApplicationId?: string;
};

export type IApplicationsReducers = {
  reloadingApplications: (
    state: IApplicationsState,
    params: {
      currentUserCoworkBranch?: ICoworkBranch;
    }
  ) => IApplicationsState;
  reloadApplicationsSucceeded: (
    state: IApplicationsState,
    params: {
      coworkingSpace: ICoworkSpace;
      applications: IApplication[];
      currentUserCoworkBranch: ICoworkBranch;
      branches: ICoworkBranch[];
    }
  ) => IApplicationsState;
  reloadApplicationsFailed: (
    state: IApplicationsState,
    error: string
  ) => IApplicationsState;
  applicationsUpdate: (
    state: IApplicationsState,
    params: {
      applications: IApplication[];
    }
  ) => IApplicationsState;
  creatingApplication: (state: IApplicationsState) => IApplicationsState;
  createApplicationSucceeded: (
    state: IApplicationsState,
    params: {
      application: IApplication;
    }
  ) => IApplicationsState;
  createApplicationFailed: (
    state: IApplicationsState,
    error: string
  ) => IApplicationsState;
};

export type IApplicationsEffects = {
  reloadApplications: (params: {}, state: IState) => void;
  createApplication: (params: IApplicationCreationProps, state: IState) => void;
  setCurrentBranch: (
    params: {
      branch: ICoworkBranch;
    },
    state: IState
  ) => void;
};

export interface IApplicationsDispatch {
  reloadApplications: () => void;
  reloadingApplications: (params: {
    currentUserCoworkBranch?: ICoworkBranch;
  }) => void;
  reloadApplicationsSucceeded: (params: {
    coworkingSpace: ICoworkSpace;
    applications: IApplication[];
    currentUserCoworkBranch: ICoworkBranch;
    branches: ICoworkBranch[];
  }) => void;
  reloadApplicationsFailed: (error: string) => void;
  applicationsUpdate: (params: { applications: IApplication[] }) => void;
  createApplication: (params: IApplicationCreationProps) => void;
  creatingApplication: () => IApplicationsState;
  createApplicationSucceeded: (params: {
    application: IApplication;
  }) => IApplicationsState;
  createApplicationFailed: (error: string) => IApplicationsState;
  setCurrentBranch: (params: { branch: ICoworkBranch }) => void;
}

export const Applications: IApplicationsModel = {
  name: "applications",
  state: {
    applications: {},
    applicationsForCurrentCowork: emptyListSubState,
    branches: []
  },
  reducers: {
    reloadingApplications: ApplicationsReducers.reloadingApplications,
    reloadApplicationsSucceeded:
      ApplicationsReducers.reloadApplicationsSucceeded,
    reloadApplicationsFailed: ApplicationsReducers.reloadApplicationsFailed,
    applicationsUpdate: ApplicationsReducers.applicationsUpdate,
    creatingApplication: ApplicationsReducers.creatingApplication,
    createApplicationSucceeded: ApplicationsReducers.createApplicationSucceeded,
    createApplicationFailed: ApplicationsReducers.createApplicationFailed
  },
  effects: {
    reloadApplications: ApplicationsEffects.reloadApplications,
    createApplication: ApplicationsEffects.createApplication,
    setCurrentBranch: ApplicationsEffects.setCurrentBranch
  }
};

// This type verifies the Dispatch types are not missing any keys
// @ts-ignore
type Verify<
  V extends never = Exclude<
    IApplicationsDispatch,
    IApplicationsState | IApplicationsEffects
  >
> = 0;



// WEBPACK FOOTER //
// ./src/state/modules/applications/applications.ts